/**
 * @generated SignedSource<<f024ae63bddd4f2cd5080eb52b35a130>>
 * @relayHash fbbfcab0125f16b0de28ce142c4640d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID manual

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SpaceOverviewSwitcherQuery$variables = {
  cloudId: string;
  spaceKey: string;
};
export type SpaceOverviewSwitcherQuery$data = {
  readonly confluence_smartSpaceOverview: {
    readonly faq: {
      readonly entries: ReadonlyArray<{
        readonly answer: string;
        readonly followUpQuestions: ReadonlyArray<string | null | undefined>;
        readonly question: string;
        readonly sources: ReadonlyArray<{
          readonly content: {
            readonly embeddedProduct: string | null | undefined;
            readonly excerpt: string;
            readonly id: string | null | undefined;
            readonly links: {
              readonly webui: string | null | undefined;
            } | null | undefined;
            readonly title: string | null | undefined;
          } | null | undefined;
        }>;
      }>;
    } | null | undefined;
    readonly summary: {
      readonly body: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SpaceOverviewSwitcherQuery = {
  response: SpaceOverviewSwitcherQuery$data;
  variables: SpaceOverviewSwitcherQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "ConfluenceSmartSpaceOverview",
    "kind": "LinkedField",
    "name": "confluence_smartSpaceOverview",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSmartSpaceOverviewSummary",
        "kind": "LinkedField",
        "name": "summary",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "body"
          }
        ]
      },
      {
        "concreteType": "ConfluenceSmartSpaceOverviewFAQ",
        "kind": "LinkedField",
        "name": "faq",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSmartSpaceOverviewFAQEntry",
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "question"
              },
              {
                "kind": "ScalarField",
                "name": "answer"
              },
              {
                "kind": "ScalarField",
                "name": "followUpQuestions"
              },
              {
                "concreteType": "ConfluenceSmartSpaceOverviewFAQSource",
                "kind": "LinkedField",
                "name": "sources",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "excerpt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "embeddedProduct"
                      },
                      {
                        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "webui"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceOverviewSwitcherQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceOverviewSwitcherQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fbbfcab0125f16b0de28ce142c4640d3",
    "id": "manual",
    "metadata": {},
    "name": "SpaceOverviewSwitcherQuery",
    "operationKind": "query",
    "text": "query SpaceOverviewSwitcherQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(cloudId:$cloudId,spaceKey:$spaceKey){summary{body},faq{entries{question,answer,followUpQuestions,sources{content{id,title,excerpt,embeddedProduct,links{webui}}}}}}}"
  }
};
})();

(node as any).hash = "75cdc869b73a88ed0c8f3587edf9aa3a";

export default node;
